<!-- Cooksy About template -->
<template>
  <div class="mt-4">
    <hr />

    <!-- Title -->
    <h2>О Cooksy <i class="bi bi-info-circle text-warning"></i></h2>

    <!-- Chat description -->
    <div class="text-secondary small mt-n2 mb-4">
      Краткая информация о Cooksy. Вы моете узнать больше о нашем сервисе
      воспользовавшись чатом с AI нажав кнопку ниже.
    </div>

    <!-- Chat image -->
    <div class="image-container">
      <img
        :src="randomImageUrl || getRandomImage()"
        class="image-chat"
        alt="Cooksy AI"
        @click="randomImageUrl = getRandomImage()"
      />
    </div>

    <!-- Chat text -->
    <div class="mt-3 mb-3">
      <p class="">
        Cooksy — это ваш персональный кулинарный помощник, созданный с помощью
        искусственного интеллекта. Наша цель — сделать процесс приготовления еды
        простым, интересным и вдохновляющим. Здесь вы можете найти тысячи
        проверенных рецептов, составить "умный" список покупок, получить советы
        от AI-шефа в режиме реального времени и даже создать свои собственные
        уникальные блюда.
      </p>
      <p>
        Задайте вопрос AI-шефу и он придет к вам на помощь. Вы можете задать
        вопрос о том как можно использовать Cooksy. Для начала общения нажмите
        на кнопку ниже и в окне чата напишите свой вопрос.
      </p>

      <!-- Chat component -->
      <ChatRecipe
        chatType="about"
        title="О Cooksy?"
        placeholder="Спросите про Cooksy..."
        @fullscreen-toggled="
          isChatFullscreenActive = $event;
          $emit('chatFullscreenActive', $event);
        "
        ref="chatRecipeComponent"
      />
      <div class="text-secondary small mt-n2 mb-4">
        AI ответит на ваши вопросы.
      </div>

      <!-- Latest Article About Cooksy -->
      <div v-if="latestArticle" class="mb-4">
        <div class="card-body">
          <div v-html="formattedArticleText" class="card-text"></div>
        </div>
      </div>

      <hr />

      <p class="">
        Мы постоянно работаем над улучшением Cooksy, добавляя новые функции и
        рецепты, чтобы каждый ваш кулинарный опыт был удачным. <br />
        <br />
        <a
          href="https://t.me/cooksy_channel"
          target="_blank"
          rel="noopener noreferrer"
          >Присоединяйтесь к нашему каналу в Telegram!</a
        >
      </p>
    </div>
  </div>
</template>

<script>
import ChatRecipe from "./ChatRecipe.vue";
export default {
  name: "CooksyAbout",

  components: { ChatRecipe },

  data() {
    return {
      isChatFullscreenActive: false,
      randomImageUrl: "",
      latestArticle: null,
      images: [
        "О Cooksy - 1",
        "О Cooksy - 2",
        "О Cooksy - 3",
        "О Cooksy - 4",
        "О Cooksy - 5",
        "О Cooksy - 6",
        "О Cooksy - 7",
        "О Cooksy - 8",
        "О Cooksy - 9",
        "О Cooksy - 10",
        "О Cooksy - 11",
      ],
    };
  },

  computed: {
    formattedArticleText() {
      if (!this.latestArticle || !this.latestArticle.post_text) {
        return "";
      }
      let text = this.latestArticle.post_text;
      // Replace **text** with <strong>text</strong>
      text = text.replace(/\*\*(.*?)\*\*/g, "<strong>$1</strong>");
      // Replace *text* or _text_ with <em>text</em>
      text = text.replace(/(\*|_)(.*?)\1/g, "<em>$2</em>");
      return text.replace(/\n/g, "<br>");
    },
  },

  methods: {
    getRandomImage() {
      let randomImage;
      do {
        const randomIndex = Math.floor(Math.random() * this.images.length);
        randomImage =
          this.$globalState.apiUrl + "/image.get/" + this.images[randomIndex];
      } while (this.randomImageUrl === randomImage);
      return randomImage;
    },

    async fetchLatestArticle() {
      try {
        const response = await this.sendCmd("article.getAboutCooksy");
        const article = JSON.parse(response);
        if (article && article.post_text) {
          this.latestArticle = article;
        }
      } catch (error) {
        console.error("Error fetching latest article about Cooksy:", error);
      }
    },
  },

  mounted() {
    this.fetchLatestArticle();
  },
};
</script>

<style scoped>
.image-container {
  width: 100%;
  display: flex;
  border-radius: 8px;
  overflow: hidden;
}

.image-chat {
  width: 100%;
  object-fit: cover;
  border-radius: 10px;

  /* Animation from RecipeView */
  transition: transform 0.3s ease-in-out;
}

.image-chat:hover {
  /* Animation from RecipeView */
  transform: scale(1.03);
}
</style>
